import { SET_CAROUSEL, FETCH_MEDIA } from "./constants";

import initialState from "./initialState";

export default (state = initialState, action) => {
	let mediaLength = 0;
	switch (action.type) {
		case SET_CAROUSEL:
			return {
				...initialState
			};
		case FETCH_MEDIA:
			Object.values(action.media).forEach(media => {
				if (media.length > 0) {
					mediaLength = 1;
				}
			});
			if (mediaLength === 0) {
				return null;
			}
			return {
				...action.media
			};

		default:
			return state;
	}
};
